import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Colors from '../colors';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { Divider } from '@mui/material';

const InfoContainer = ({
  title,
  infoRows,
  onClickHandler,
  showEditIcon = true
}) => {
  return (
    <div>
      <h3>
        {title}
      </h3>
      <Box
        sx={{
          minHeight: '60px',
          boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
          border: `1px solid ${Colors.green}`,
          borderRadius: '10px',
          padding: '10px',
          position: 'relative'
        }}
        onClick={onClickHandler} >
        <Stack >
          {infoRows.map((row, index) => (
            <React.Fragment key={index}>
              {row}
              {index < infoRows.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </Stack>
        {showEditIcon && <BorderColorIcon sx={{ 
          position: 'absolute', 
          bottom: 15, 
          right: 15, 
          color: `${Colors.mediumGray}` 
          }} />}
      </Box>
    </div>
  );
};

export default InfoContainer;
